import type { Theme } from '../types';
import type { Components } from '@mui/material/styles';

export const MuiListItemAvatar = {
  styleOverrides: { root: { minWidth: 'auto' } },
} satisfies Components<Theme>['MuiListItemAvatar'];
